module.exports = __webpack_public_path__ + "img/success-svgrepo-com.37c6455f.svg";